import * as React from "react";
import {
    BooleanInput,
    ReferenceInput,
    AutocompleteInput,
    FormDataConsumer,
    required,
} from 'react-admin';

const HomeSectionVenue = ({ isCreate = false }) => (
    <React.Fragment>
        <h3>Venue</h3>
        <BooleanInput
            label="Mekan kullanmak istiyor musun?"
            source="useVenue"
            defaultValue={isCreate ? false : undefined}
        />
        <FormDataConsumer>
            {({ formData }) => {
                if (!formData?.useVenue) return null;

                return (
                    <React.Fragment>
                        <ReferenceInput
                            source="venue"
                            reference="venues"
                            label="Venue Filter"
                            sort={{ field: 'name', order: 'ASC' }}
                            perPage={200}
                            defaultValue={isCreate ? null : undefined}
                        >
                            <AutocompleteInput
                                optionText={(r) => `${r.name}`}
                                matchSuggestion={() => true}
                                filterToQuery={(searchText) => ({ name: searchText })}
                                label="Mekan"
                                fullWidth
                                validate={required()}
                                defaultValue={isCreate ? null : undefined}
                            />
                        </ReferenceInput>
                        <span style={{ fontSize: 12, display: 'block', marginTop: -8, marginBottom: 16 }}>
                            Web ve mobilde section başlığı olarak seçilen mekanın adı kullanılır.
                        </span>
                    </React.Fragment>
                );
            }}
        </FormDataConsumer>
    </React.Fragment>
);

export default HomeSectionVenue;
